import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './Home';
import About from './about';
import AITrainerKit from './AI-Trainer-Kit';  
import 'bootstrap/dist/css/bootstrap.min.css';
import ConnectWithUs from './Contact-Us';
import RandD from './Research';
import AIEducationHero from './Programs';
import Career from './Career'; 
import Space404Page from './404';
import StudentMembership from './Student-Membership';
import AIInternshipProgram from './AI-Internship-Program';
import AIWorkshopLanding from './Workshop-Bootcamp';
import InstitutionalPartnerships from './Institution-Partnership';
import AITrainerKitProgram from './AI-Training-Kit-Program';
import IndustrialVisitProgram from './Industrial-Visit';
import CorporatePartnership from './Corporate-Partnership';
import BecomePartner from './BecomePartner';
import PrivacyPolicy from './Privacy-Policy';

function App() {
  return (
    <div>
      <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<About />} />
        <Route path="/ai-trainer-kit" element={<AITrainerKit />} />
        <Route path="/contact-us" element={<ConnectWithUs />} />
        <Route path="/research" element={<RandD />} />
        <Route path="/programs" element={<AIEducationHero />} />
        <Route path="/career" element={<Career />} />
        <Route path="/student-membership" element={<StudentMembership />} />
        <Route path="*" element={<Space404Page />} />
        <Route path="/ai-internship-program" element={<AIInternshipProgram />} />
        <Route path="/workshop-bootcamp" element={<AIWorkshopLanding />} />
        <Route path="/institutional-partnerships" element={<InstitutionalPartnerships />} />
        <Route path="/ai-training-kit-program" element={<AITrainerKitProgram />} />
        <Route path="/industrial-visit-program" element={<IndustrialVisitProgram />} />
        <Route path="/corporate-partnership" element={<CorporatePartnership />} />
        <Route path="/become-partner" element={<BecomePartner />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      </Routes>
    </Router>
    </div>
  );
}

export default App;